import { useContext } from "react";

import { OutputDocumentsContext } from "./OutputDocumentsContext";

export function useOutputDocuments() {
  const context = useContext(OutputDocumentsContext);
  if (!context) {
    throw new Error("useOutputDocuments must be used within a OutputDocumentsProvider");
  }
  return context;
}
